import React from 'react';
import { Card, CardBody, CardHeader, CardTitle } from "@progress/kendo-react-layout"
import { Button } from '@progress/kendo-react-buttons';
import { getDateStr } from '../utils/getDateStr';
import { useDispatch, useSelector } from 'react-redux';

export const Group = props => {
  const { group } = props;
  const { user, token } = useSelector(state => state.authReducer);

  let createdStr = getDateStr(group.createdAt);
  let updatedStr = getDateStr(group.updatedAt);
  
  return (
    <Card style={{ maxWidth: 350, minWidth: 350, height: '100%' }}>
      <CardHeader
        style={{
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <CardTitle>{group.name}</CardTitle>
        <div>
          <Button
            className="k-button k-primary k-flat"
            style={{ marginRight: "5px" }}
            onClick={() => props.user(group, props.viewOnly && !user.notificationOnly && group.site.id == user.site.id)}
            iconClass="k-icon k-i-user"
          />
          {(props.viewOnly && !user.notificationOnly && group.site.id == user.site.id) && <>
            <Button
            className="k-button k-primary k-flat"
            style={{ marginRight: "5px" }}
            onClick={() => props.edit(group)}
            iconClass="k-icon k-i-pencil"
            />
            <Button
            className="k-button k-flat"
            onClick={() => props.delete(group)}
            iconClass="k-icon k-i-trash"
            style={{ color: 'red' }}
            />
          </>}
        </div>
      </CardHeader>
      <CardBody
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-evenly'
        }}
      >
        <span style={{ paddingBottom: 25 }}>{group.Users.length} Contacts</span>
        {createdStr && (<span style={{ fontSize: 12 }}>Created {createdStr}</span>)}
        {updatedStr && (<span style={{ fontSize: 12 }}>Updated {updatedStr}</span>)}
      </CardBody>
    </Card>
  )
}